import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { MenuIcon } from '../icons';
import styles from './menu-button.scss';

const MenuButton = ({ items, value, onChange: handleChange, ...rest }) => {
  return (
    <span className={styles.container} {...rest} data-hook="menu-button">
      <MenuIcon className="button-primary-icon-fill"/>
      <span className={styles.clickable}>
        <select className={styles.select} onChange={handleChange} value={value} data-hook="menu-button__select">
          {map(items, ({ value, label }) =>
            <option key={value} value={value}>
              {label}
            </option>
          )}
        </select>
      </span>
    </span>
  );
};

MenuButton.propTypes = {
  items: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default MenuButton;



// WEBPACK FOOTER //
// ./app/components/menu-button/menu-button.js